import { css } from '@emotion/css'

import { colors, borderRadius, fontSize, spacing, shorthandHelper } from '@offerzen/pinata'

const styles = {
  container: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    padding: spacing.default,
    marginBottom: spacing.large,
  }),

  fileInput: css({
    display: 'none',
  }),

  label: css({
    fontSize: fontSize.default,
    margin: 0,
    color: colors.oxfordBlue,
  }),

  button: css({
    border: `1px solid ${colors.cornflowerBlue}`,
    borderRadius: borderRadius.default,
    color: colors.cornflowerBlue,
    padding: shorthandHelper([spacing.small, spacing.large]),
    fontSize: fontSize.small,
    lineHeight: 1.8,
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: colors.cornflowerBlue,
      color: colors.white,
    },
  }),
}

export default styles
